import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "@hypexone/uicore";
// import "./Announcement.css"; // Import the CSS file with the keyframes

const Announcement: React.FC = () => {
  const notifications = useSelector(
    (state: RootState) => state.auth.notifications
  );

  return notifications && notifications.length > 0 ? (
    <div className="flex w-full text-sm text-blue-400 font-bold overflow-hidden">
      <div className="md:w-[100%] w-full md:overflow-hidden">
        <div className="flex gap-3 text-sm animate-marquee whitespace-nowrap">
          {notifications.map((announcement, index) => (
            <p key={index} className="flex gap-1 font-sans font-bold text-xs ">
              <span>{announcement.message}</span>
            </p>
          ))}
        </div>
      </div>
    </div>
  ) : null;
};

export default Announcement;
